import React, { useState, useEffect, useMemo } from 'react';
import { useSwipeable } from 'react-swipeable';
import styles from "../styles/gallerysubmodule.module.css";
import GalleryCard from '../../common/GalleryCard';
import { motion, AnimatePresence } from 'framer-motion';
import { MdNavigateNext, MdNavigateBefore } from "react-icons/md";
import axios from 'axios';

const Media = () => {
  const [photos, setPhotos] = useState([]);
  const [selectedPhotoIndex, setSelectedPhotoIndex] = useState(null);

  const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;
  const fileBaseUrl = apiBaseUrl.replace('/api', '');

  useEffect(() => {
    axios
      .get(`${apiBaseUrl}/documents?type=gallery&subType=media`)
      .then((res) => setPhotos(res.data))
      .catch((error) => console.error('Error fetching media gallery:', error));
  }, [apiBaseUrl]);

  const handlePhotoClick = (index) => {
    setSelectedPhotoIndex(index);
  };

  const handleClose = () => setSelectedPhotoIndex(null);

  const handlePrev = () => {
    setSelectedPhotoIndex((prev) => (prev === 0 ? photos.length - 1 : prev - 1));
  };

  const handleNext = () => {
    setSelectedPhotoIndex((prev) => (prev === photos.length - 1 ? 0 : prev + 1));
  };

  const memoizedPhotos = useMemo(() => photos, [photos]);

  const swipeHandlers = useSwipeable({
    onSwipedLeft: handleNext,
    onSwipedRight: handlePrev,
    trackMouse: true,
  });

  return (
    <div className={styles.photos}>
      <h4 className={styles.friends_of_snehwan_title}>MEDIA OF SNEHWAN</h4>
      {memoizedPhotos.length > 0 ? (
        <motion.div
          className={styles['photo-gallery']}
          initial="hidden"
          animate="visible"
          variants={{
            hidden: { opacity: 0 },
            visible: { opacity: 1, transition: { staggerChildren: 0.2 } },
          }}
        >
          {memoizedPhotos.map((photo, index) => (
            <div key={index} onClick={() => handlePhotoClick(index)}>
              <GalleryCard photo={photo} />
            </div>
          ))}
        </motion.div>
      ) : (
        <motion.p
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, delay: 0.2 }}
        >
          Loading media...
        </motion.p>
      )}

      <AnimatePresence>
        {selectedPhotoIndex !== null && (
          <motion.div
            className={styles.modalOverlay}
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.3 }}
          >
            <div className={styles.modalContent} {...swipeHandlers}>
              <button
                onClick={handleClose}
                style={{
                  position: "absolute",
                  top: "8px",
                  right: "8px",
                  background: "rgba(0, 0, 0, 0.5)",
                  border: "none",
                  fontSize: "18px",
                  cursor: "pointer",
                  color: "white",
                  zIndex: 1000,
                  width: "28px",
                  height: "28px",
                  lineHeight: "1",
                  padding: "0",
                }}
              >
                ✕
              </button>

              <button
                onClick={handlePrev}
                style={{
                  position: "absolute",
                  top: "50%",
                  left: "8px",
                  transform: "translateY(-50%)",
                  background: "rgba(0, 0, 0, 0.5)",
                  border: "none",
                  borderRadius: "70%",
                  color: "white",
                  fontSize: "20px",
                  width: "32px",
                  height: "32px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  cursor: "pointer",
                  zIndex: 1000,
                  padding: "0",
                }}
              >
                <MdNavigateBefore />
              </button>
              <img
                src={`${fileBaseUrl}${photos[selectedPhotoIndex]?.path}`}
                alt={photos[selectedPhotoIndex]?.title}
                className={styles.modalImage}
              />
              <button
                onClick={handleNext}
                style={{
                  position: "absolute",
                  top: "50%",
                  right: "8px",
                  transform: "translateY(-50%)",
                  background: "rgba(0, 0, 0, 0.5)",
                  border: "none",
                  borderRadius: "70%",
                  color: "white",
                  fontSize: "20px",
                  width: "32px",
                  height: "32px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  cursor: "pointer",
                  zIndex: 1000,
                  padding: "0",
                }}
              >
                <MdNavigateNext />
              </button>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};

export default Media;
